<template>
  <div class="home">
    <custom-section class="section pa-0 pa-md-5">
      <NavbarOne
        class="d-md-none d-lg-none"
        :showNavbar="showNavbar"
        :showCart="showCart"
        :showCartDesktop="showCartDesktop"
        :showSearch="showSearch"
        :showLogo="showLogo"
      >
      </NavbarOne>
      <!-- <div class="d-md-none d-flex flex-grow-1 align-center mb-3">
        <h4 class="tab-switch">{{ $t("role_as") }}:</h4>
        <tab />
      </div> -->
      <TabContent
        :listTab="listMenu"
        :listContent="listContent"
        class="mb-6 mt-1"
        :activeTab="activeTab"
        @changeTab="id => (activeTab = id)"
      >
        <template v-slot:tabs_content="content">
          <v-row v-if="activeTab == '1' || activeTab == '2'" dense>
            <v-col cols="6" class="d-none d-lg-block">
              <div v-for="(item, index) of content.data" :key="index">
                <v-row
                  no-gutters
                  class="list-data"
                  v-if="
                    item.valueTitle == 'EMAIL' ||
                    item.valueTitle == 'MOBILE PHONE' ||
                    item.valueTitle == 'HOME PHONE' ||
                    item.valueTitle == 'ID CARD'
                  "
                >
                  <v-col class="text-title">
                    {{ item.valueTitleLang }}
                  </v-col>
                  <v-col class="text-value">
                    {{ item.valueLeft }}
                  </v-col>
                </v-row>
                <v-row
                  no-gutters
                  class="list-data"
                  v-if="
                    item.valueTitle !== 'EMAIL' &&
                    item.valueTitle !== 'MOBILE PHONE' &&
                    item.valueTitle !== 'HOME PHONE' &&
                    item.valueTitle !== 'ID CARD'
                  "
                >
                  <v-col class="text-new-title">
                    {{ item.valueLeft }}
                  </v-col>
                </v-row>
              </div>
            </v-col>
            <v-col cols="6" class="d-none d-lg-block">
              <div v-for="(item, index) of content.dataRight" :key="index">
                <v-row no-gutters class="list-data">
                  <v-col class="text-title">
                    {{ item.title }}
                  </v-col>
                  <v-col class="text-value">
                    {{ item.value }}
                  </v-col>
                </v-row>
              </div>
            </v-col>
          </v-row>
          <v-row v-if="activeTab == '1' || activeTab == '2'" dense>
            <v-col class="d-block d-lg-none" cols="12">
              <div v-for="item of content.dataMobile" :key="item.id">
                <v-row no-gutters class="list-data">
                  <v-col class="text-new-title">
                    {{ item.valueLeft }}
                  </v-col>
                </v-row>
              </div>
              <div
                v-for="(item, index) of content.dataMobileRight"
                :key="index"
              >
                <v-row no-gutters class="list-data">
                  <v-col class="text-title">
                    {{ item.title }}
                  </v-col>
                  <v-col class="text-value">
                    {{ item.value }}
                  </v-col>
                </v-row>
              </div>
            </v-col>
          </v-row>
          <v-row v-if="activeTab == '3'" dense>
            <v-col cols="12">
              <card>
                <template v-slot:body>
                  <v-col cols="12" class="pa-0">
                    <AccountTab />
                  </v-col>
                </template>
              </card>
            </v-col>
          </v-row>

          <v-row v-if="activeTab == '4'" dense>
            <v-col cols="12">
              <card>
                <template v-slot:body>
                  <v-col cols="12">
                    <PatientList />
                  </v-col>
                </template>
              </card>
            </v-col>
          </v-row>
        </template>
      </TabContent>
      <!-- graph and chart -->
      <v-row v-if="activeTab == '1'">
        <v-col cols="12" lg="7">
          <v-row>
            <v-col cols="12">
              <card rounded shadow>
                <template v-slot:header>
                  <div class="card__header">
                    <div class="d-flex justify-space-between align-center">
                      <heading-card
                        :title="$t('page.profile.number_of_patient')"
                      />
                      <!-- <sub-heading-card title="5 patient out of 10"/> -->
                      <!-- @changeDate="(nilai) => updateRevenue(nilai)" -->
                      <select-show
                        :items="DateFilterItems"
                        :value="dateFilterDefaultValue"
                        @changeDate="nilai => updateAllReport(nilai)"
                      />
                      <!-- <date-range-picker :listDate='thisWeek' @pickDate="date => updateRevenue(date)" class="float-right"/> -->
                    </div>
                    <!-- <Progressbar color="#00a4b3" progress="60" class="my-3" /> -->
                    <!-- <heading-card :title="selectedDateNow" class="mb-8" /> -->
                    <!-- <Datepicker
                    :listDate="thisWeek"
                    type="week"
                    @pickDate="date => selectRevenueByDate(date)" 
                  /> -->
                  </div>
                </template>
                <template v-slot:body>
                  <v-data-table
                    :headers="patientHeaders"
                    :items="patientDatas"
                    :items-per-page="25"
                    item-key="id"
                    mobile-breakpoint="0"
                    class="table-stick-sap super-dense"
                  >
                    <template v-slot:item="{ item }">
                      <tr>
                        <td valign="top" class="pt-2">{{ item.order_date }}</td>
                        <td valign="top" class="pt-2 tb-wide">
                          <a
                            href="javascript:void(0);"
                            @click="openDialogOrder(item)"
                            >{{ item.order_no }}</a
                          >
                        </td>
                        <!-- <td valign="top" class="pt-2">{{ item.patient_id }}</td> -->
                        <td valign="top" class="pt-2">
                          {{ item.patient_name }}
                        </td>
                        <!-- <td valign="top" class="pt-2">
                        <v-btn
                          elevation="2"
                          color="warning"
                          dark
                          x-small
                          @click.stop="dialog = true"
                          v-if="item.result == 'warning'"
                        >
                          Warning
                        </v-btn>
                        <v-btn
                          elevation="2"
                          x-small
                          color="error"
                          v-if="item.result == 'danger'"
                        >
                          Danger
                        </v-btn>
                        <v-btn
                          elevation="2"
                          x-small
                          color="success"
                          v-if="item.result == 'ok'"
                        >
                          OK
                        </v-btn>
                      </td> -->
                        <td valign="top" class="pt-2">
                          <v-btn
                            elevation="2"
                            color="warning"
                            dark
                            x-small
                            @click.stop="dialog = true"
                            v-if="item.result == 'warning'"
                          >
                            {{ $t("warning") }}
                          </v-btn>
                          <v-btn
                            elevation="2"
                            x-small
                            color="error"
                            v-if="item.result == 'danger'"
                          >
                            {{ $t("danger") }}
                          </v-btn>
                          <v-btn
                            elevation="2"
                            x-small
                            color="success"
                            v-if="item.result == 'ok'"
                          >
                            {{ $t("oke") }}
                          </v-btn>
                        </td>
                        <!-- <td valign="top" class="pt-2">{{ item.status }}</td> -->
                        <td align="right" valign="top" class="pt-2">
                          {{ formater(item.referral) }}
                        </td>
                      </tr>
                    </template>
                    <!-- <template v-slot:[`body.append`]>
                      <tr class="sticky-table-footer">
                        <td />
                        <td />
                        <td />
                        <td v-text="$t('page.profile.total')" />
                        <td
                          class="pt-2"
                          align="right"
                          v-text="formater(sumReferral())"
                        />
                      </tr>
                    </template> -->
                    <template v-slot:[`footer`]>
                      <v-divider></v-divider>
                      <div class="d-flex align-end justify-end pa-3">
                        <p
                          class="mb-0 mr-3"
                          style="font-size: 12px; font-weight: 600"
                        >
                          {{ $t("page.profile.total") }} :
                        </p>
                        <p
                          class="mb-0"
                          style="font-size: 12px; font-weight: 600"
                        >
                          {{ formater(sumReferral()) }}
                        </p>
                      </div>
                    </template>
                  </v-data-table>
                </template>
              </card>
            </v-col>
            <v-col>
              <card rounded shadow>
                <template v-slot:header>
                  <div class="card__header">
                    <div class="d-flex justify-space-between align-center">
                      <heading-card
                        :title="$t('page.profile.total_referral')"
                      />
                      <select-show
                        :items="DateFilterItems"
                        :value="dateFilterDefaultValue"
                        @changeDate="nilai => updateAllReport(nilai)"
                      />
                    </div>
                    <!-- <sub-heading-card :title="selectedMonthNow" /> -->
                  </div>
                </template>
                <template v-slot:body>
                  <v-data-table
                    :headers="referralMonthHeader"
                    :items="referralMonthData"
                    :items-per-page="75"
                    hide-default-footer
                    item-key="id"
                    mobile-breakpoint="0"
                    class="table-stick super-dense"
                  >
                    <template v-slot:item="{ item }">
                      <tr>
                        <td class="tb-wide" style="height: 25px !important">
                          <a
                            href="javascript:void(0);"
                            @click="openDialogReferral(item.date)"
                            >{{ item.date }}</a
                          >
                        </td>
                        <td align="right" style="height: 25px !important">
                          {{ item.number_of_patients }}
                        </td>
                        <td align="right" style="height: 25px !important">
                          {{ formater(item.referral_fee) }}
                        </td>
                      </tr>
                    </template>
                    <!-- <template v-slot:[`body.append`]>
                      <tr class="sticky-table-footer">
                        <td
                          style="height: 25px !important"
                          v-text="$t('page.profile.total')"
                        /> -->
                    <!-- <td style="height: 25px !important;"
                          align="right"
                          v-text="sumReferralMonth('patient')"
                        /> -->
                    <!-- <td
                          style="height: 25px !important"
                          align="right"
                          v-text="formater(sumReferralMonth('HSL'))"
                        />
                      </tr>
                    </template> -->
                    <template v-slot:[`footer`]>
                      <v-divider></v-divider>
                      <v-row class="pt-2">
                        <v-col cols="6" class="d-flex align-end justify-start">
                          <p
                            class="mb-0 ml-3"
                            style="font-size: 12px; font-weight: 600"
                          >
                            {{ $t("page.profile.total") }} :
                          </p>
                        </v-col>
                        <v-col cols="6" class="d-flex align-end justify-end">
                          <p
                            class="mb-0 mr-3"
                            style="font-size: 12px; font-weight: 600"
                          >
                            {{ formater(sumReferralMonth("referral_fee")) }}
                          </p>
                        </v-col>
                      </v-row>
                    </template>
                  </v-data-table>
                </template>
              </card>
            </v-col>
          </v-row>
        </v-col>

        <v-col cols="12" lg="5">
          <v-row>
            <v-col cols="12">
              <card rounded shadow>
                <template v-slot:header>
                  <div class="card__header">
                    <div class="d-flex justify-space-between align-center">
                      <heading-card
                        :title="$t('page.profile.patient_summary')"
                      />
                      <!-- @changeDate="(nilai) => updateSummaryChart(nilai)" -->

                      <select-show
                        :items="DateFilterItems"
                        :value="dateFilterDefaultValue"
                        @changeDate="nilai => updateAllReport(nilai)"
                      />
                    </div>
                  </div>
                </template>
                <template v-slot:body>
                  <v-col cols="12">
                    <div class="card-chart">
                      <h5 class="mb-5">
                        <div
                          class="d-flex justify-start align-center chart-title"
                        >
                          <radio />
                          <p class="mb-0 ml-2">
                            {{ $t("page.profile.total_patient") }}
                          </p>
                        </div>
                      </h5>
                      <apex-summary-chart
                        :data="dataChart"
                        v-if="dataChart != null"
                        :activeRange="dateFilterDefaultValue"
                      />
                    </div>
                  </v-col>
                </template>
              </card>
            </v-col>

            <v-col cols="12">
              <card rounded shadow>
                <template v-slot:header>
                  <div class="card__header">
                    <div class="d-flex justify-space-between align-center">
                      <heading-card
                        :title="$t('page.profile.referral_fee_summary')"
                      />
                      <!-- @changeDate="(nilai) => updateReferralChart(nilai)" -->

                      <select-show
                        :items="DateFilterItems"
                        :value="dateFilterDefaultValue"
                        @changeDate="nilai => updateAllReport(nilai)"
                      />
                    </div>
                  </div>
                </template>
                <template v-slot:body>
                  <v-col cols="12">
                    <div class="card-chart">
                      <h5 class="mb-5">
                        <div
                          class="d-flex justify-start align-center chart-title"
                        >
                          <description />
                          <p class="mb-0 ml-2">
                            {{ $t("page.profile.referral_fee") }}
                          </p>
                        </div>
                      </h5>
                      <apex-referral-chart
                        :data="dataReferralChart"
                        v-if="dataReferralChart != null"
                        :activeRange="dateFilterDefaultValue"
                      />
                    </div>
                  </v-col>
                </template>
              </card>
            </v-col>

            <v-col cols="12">
              <card rounded shadow>
                <template v-slot:header>
                  <div class="card__header">
                    <div class="d-flex justify-space-between align-center">
                      <heading-card :title="$t('page.profile.patient_list')" />
                    </div>
                  </div>
                </template>
                <template v-slot:body>
                  <v-col cols="12">
                    <div class="card-chart">
                      <v-data-table
                        :headers="headers"
                        :items="datas"
                        item-key="id"
                        mobile-breakpoint="0"
                        class="table-list-patient"
                      >
                        <template v-slot:item="{ item }">
                          <tr>
                            <td>{{ item.date }}</td>
                            <td align="right" valign="center">
                              {{ item.patient }}
                            </td>
                            <td align="right" valign="center">
                              {{ formater(item.fee) }}
                            </td>
                          </tr>
                        </template>
                        <template v-slot:[`body.append`]>
                          <tr class="sticky-table-footer">
                            <td v-text="'Total'" />
                            <td
                              align="right"
                              valign="center"
                              v-text="sumField('patient')"
                            />
                            <td
                              align="right"
                              valign="center"
                              v-text="formater(sumField('fee'))"
                            />
                          </tr>
                        </template>
                      </v-data-table>
                    </div>
                  </v-col>
                </template>
              </card>
            </v-col>
          </v-row>
        </v-col>
      </v-row>

      <v-row v-if="activeTab == '2'">
        <v-col cols="12">
          <card rounded shadow>
            <!-- <template v-slot:header>
            <div class="card__header">
              <div class="d-flex justify-space-between align-center">
                <heading-card title="Hospital Information" />
              </div>
            </div>
          </template> -->
            <template v-slot:body>
              <v-col cols="12">
                <HospitalTab v-if="activeTab == '2'" />
              </v-col>
            </template>
          </card>
        </v-col>
      </v-row>
      <v-row v-if="activeTab == '2'">
        <v-col cols="12">
          <card rounded shadow>
            <template v-slot:body>
              <v-col cols="12">
                <EducationTab v-if="activeTab == '2'" />
              </v-col>
            </template>
          </card>
        </v-col>
      </v-row>
      <v-row v-if="activeTab == '2'">
        <v-col cols="12">
          <card rounded shadow>
            <template v-slot:body>
              <v-col cols="12">
                <LicenseTab v-if="activeTab == '2'" />
              </v-col>
            </template>
          </card>
        </v-col>
      </v-row>

      <v-row v-if="activeTab == '3'">
        <v-col cols="12">
          <card rounded shadow>
            <template v-slot:body>
              <v-col cols="12">
                <TaxInfo :dataTaxInfo="dataTaxInfo" v-if="activeTab == '3'" />
              </v-col>
            </template>
          </card>
        </v-col>
      </v-row>

      <v-row v-if="activeTab == '3'">
        <v-col cols="12">
          <card rounded shadow>
            <template v-slot:body>
              <v-col cols="12">
                <AccountBalanceInfo v-if="activeTab == '3'" />
              </v-col>
            </template>
          </card>
        </v-col>
      </v-row>

      <!-- start modal popup daily referral month (dialog_referral)-->
      <template>
        <v-row justify="center">
          <v-dialog v-model="dialog_referral">
            <v-card>
              <v-card-title>
                <v-col cols="12" md="6" no-gutters>
                  <span class="text-h5">{{
                    $t("page.profile.patient_list")
                  }}</span>
                </v-col>
                <v-col cols="12" md="6" no-gutters>
                  <span class="text-h5 float-right"
                    >{{ $t("date") }} :
                    {{ dataDialogReferral.selected_date }}</span
                  >
                </v-col>
              </v-card-title>
              <v-divider></v-divider>
              <v-card-text>
                <v-row>
                  <v-col cols="12">
                    <card rounded shadow>
                      <template v-slot:header>
                        <div class="card__header"></div>
                      </template>
                      <template v-slot:body>
                        <v-data-table
                          :headers="patientHeadersPopup"
                          :items="patientDatasPopup"
                          item-key="id"
                        >
                          <template v-slot:item="{ item }">
                            <tr>
                              <td valign="top" class="pt-2">
                                <!-- <a
                                  href="javascript:void(0);"
                                  @click="openDialogOrder(item)"
                                  >{{ item.order_no }}</a
                                > -->
                                {{ item.order_no }}
                              </td>
                              <td valign="top" class="pt-2">
                                {{ item.patient_id }}
                              </td>
                              <td valign="top" class="pt-2">
                                {{ item.patient_name }}
                              </td>
                              <!-- <td valign="top" class="pt-2">
                                <v-btn
                                  elevation="2"
                                  color="warning"
                                  dark
                                  x-small
                                  @click.stop="dialog = true"
                                  v-if="item.result == 'warning'"
                                >
                                  {{ $t("warning") }}
                                </v-btn>
                                <v-btn
                                  elevation="2"
                                  x-small
                                  color="error"
                                  v-if="item.result == 'danger'"
                                >
                                  {{ $t("danger") }}
                                </v-btn>
                                <v-btn
                                  elevation="2"
                                  x-small
                                  color="success"
                                  v-if="item.result == 'ok'"
                                >
                                  {{ $t("oke") }}
                                </v-btn>
                              </td>
                              <td valign="top" class="pt-2">
                                {{ item.status }}
                              </td> -->
                              <td align="right" valign="top" class="pt-2">
                                {{ formater(item.referral) }}
                              </td>
                            </tr>
                          </template>
                          <template v-slot:[`body.append`]>
                            <tr class="sticky-table-footer">
                              <td />
                              <td />
                              <!-- <td />
                              <td /> -->
                              <td v-text="'Total'" />
                              <td
                                align="right"
                                v-text="formater(sumReferralPopup())"
                              />
                            </tr>
                          </template>
                        </v-data-table>
                      </template>
                    </card>
                  </v-col>
                </v-row>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  color="primary darken-1"
                  text
                  @click="dialog_referral = false"
                >
                  {{ $t("close") }}
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-row>
      </template>
      <DialogOrderDetail
        v-if="dialog_order"
        :item="dataDialogOrder"
        :tampilkan="dialog_order"
        @toggleDialog="is_show => toggleDialogOrder(is_show)"
      />
    </custom-section>
  </div>
</template>

<script>
import Card from "@/components/v2/card/index.vue";
import HeadingCard from "@/components/Heading/HeadingCard.vue";
// import SubHeadingCard from "@/components/Heading/SubHeadingCard.vue";
import SelectShow from "@/components/v2/select/SelectShow.vue";
// import SelectBulanBerjalan from "@/components/v2/select/SelectBulanBerjalan.vue";
// import Progressbar from "@/components/v2/progressbar/index.vue";
import moment from "moment";
import ApexSummaryChart from "@/views/v2/Patient/Chart/ApexSummaryChart.vue";
import ApexReferralChart from "@/views/v2/Patient/Chart/ApexReferralChart.vue";
import Radio from "@/components/v2/radio/index.vue";
import Auth from "@/service/auth_service";
import API from "@/service/api_service";
// import Tab from "@/components/v2/switch_account/tab.vue";
import Description from "@/components/v2/radio/referral.vue";
import TabContent from "@/components/v2/tabs/index.vue";
import EducationTab from "@/views/v2/Doctor/Tabs/EducationTab.vue";
import LicenseTab from "@/views/v2/Doctor/Tabs/LicenseTab.vue";
import AccountTab from "@/views/v2/Doctor/Tabs/AccountTab.vue";
import TaxInfo from "@/views/v2/Doctor/Tabs/TaxInfo.vue";
import AccountBalanceInfo from "@/views/v2/Doctor/Tabs/AccountBalanceInfo.vue";
import HospitalTab from "@/views/v2/Doctor/Tabs/HospitalTab.vue";
import PatientList from "@/views/v2/Doctor/Tabs/PatientList.vue";
import CustomSection from "@/components/v2/section/index.vue";
import DialogOrderDetail from "@/components/v2/dialog/dialogOrderDetail.vue";
import NavbarOne from "@/components/v2/topbar/navbar_one.vue";
// import axios from "axios";

export default {
  components: {
    // Tab,
    Card,
    HeadingCard,
    // SubHeadingCard,
    SelectShow,
    // Progressbar,
    // Datepicker,
    // DateRangePicker,
    Radio,
    Description,
    TabContent,
    EducationTab,
    AccountTab,
    LicenseTab,
    TaxInfo,
    AccountBalanceInfo,
    HospitalTab,
    PatientList,
    CustomSection,
    // SelectBulanBerjalan,
    DialogOrderDetail,
    NavbarOne,
    ApexSummaryChart,
    ApexReferralChart,
  },
  data: () => ({
    showNavbar: true,
    showCart: false,
    showCartDesktop: false,
    showSearch: false,
    showLogo: true,
    dateNow: moment().format("DD MMMM YYYY, dddd"),
    monthNow: moment().format("MMMM YYYY"),
    dateString_today: null,
    dateString_thisWeek: null,
    dateString_thisMonth: null,
    dateString_lastMonth: null,
    dateString_last3Month: null,
    dateString_thisYear: null,
    dateString_lifetime: null,
    DateFilterItems: [],
    // dateFilterDefaultValue : { dateValue:'this_week', dateLabel:'This Week'},
    dateFilterDefaultValue: "this_month",
    selectedDateNow: "",
    selectedMonthNow: "",
    thisWeek: [],
    activeDoughnut: 1,
    percentDoughnut: 0,
    colorPercent: "#2ED47A",
    listPatient: null,
    listMenu: null,
    listContent: null,
    dataTaxInfo: null,
    dataChart: [],
    dataReferralChart: [],
    headers: [],
    datas: [
      {
        date: "10-JAN-2022",
        patient: 5,
        fee: 1000000,
      },
      {
        date: "10-FEB-2022",
        patient: 10,
        fee: 2000000,
      },
      {
        date: "10-MAR-2022",
        patient: 7,
        fee: 6400000,
      },
      {
        date: "10-APR-2022",
        patient: 14,
        fee: 2400000,
      },
    ],
    patientHeaders: [],
    patientDatas: [
      {
        order_no: null,
      },
    ],
    patientHeadersPopup: [],
    patientDatasPopup: [],
    referralMonthHeader: [],
    referralMonthData: [],
    activeTab: "",
    dialog: false,
    dialog_referral: false,
    dialog_order: false,
    dataDialogReferral: {
      selected_date: null,
      selected_datas: null,
    },
    dataDialogOrder: {
      order_id: null,
      list: [
        {
          document_information: {
            number_of_report: null,
            medical_record_number: null,
            datetime_observation: null,
            gender: null,
            plant: null,
            primary_doctor: null,
            lab_chief: null,
          },
          customers_information: {
            patient_name: null,
            address: null,
            city: null,
            province: null,
            postal_code: null,
            country: null,
            dob: null,
            patient_age: null,
          },
          product: {
            product_id: null,
            product_code: null,
            product_name: null,
          },
        },
      ],
    },
    bulanSekarang: null,
    bulanBerjalan: [],
  }),
  mounted() {
    this.getFilterDateStrings();
  },
  created() {
    (this.patientHeadersPopup = [
      {
        text: this.$t("page.profile.order_no"),
        value: "order_no",
        sortable: false,
        align: "center",
      },
      {
        text: this.$t("page.profile.patient_id"),
        value: "patient_id",
        sortable: false,
        align: "center",
      },
      {
        text: this.$t("page.profile.patient_name"),
        value: "patient_name",
        sortable: false,
        align: "center",
      },
      // { text: "Result", value: "result", sortable: false },
      // { text: "Status", value: "status", sortable: false },
      {
        text: this.$t("page.profile.referral_fee"),
        value: "referral",
        sortable: false,
        align: "center",
      },
    ]),
      (this.DateFilterItems = [
        // { dateValue: "today", dateLabel: this.$t("today") },
        // { dateValue: "this_week", dateLabel: this.$t("this_week") },
        { dateValue: "this_month", dateLabel: this.$t("this_month") },
        { dateValue: "last_month", dateLabel: this.$t("last_month") },
        { dateValue: "last_3_month", dateLabel: this.$t("last_3_month") },
        { dateValue: "this_year", dateLabel: this.$t("this_year") },
        { dateValue: "life_time", dateLabel: this.$t("lifetime") },
      ]);
    this.headers = [
      {
        text: this.$t("page.profile.date"),
        value: "date",
        sortable: false,
        align: "center",
        width: "130px",
      },
      {
        text: this.$t("page.profile.no_of_patients"),
        value: "patient",
        sortable: false,
        align: "center",
        width: "150px",
      },
      {
        text: this.$t("page.profile.referral_fee"),
        value: "fee",
        sortable: false,
        align: "center",
        width: "150px",
      },
    ];
    this.patientHeaders = [
      {
        text: this.$t("page.profile.order_date"),
        value: "order_date",
        sortable: false,
        align: "center",
        width: "150px",
      },
      {
        text: this.$t("page.profile.order_no"),
        value: "order_no",
        sortable: false,
        align: "center",
        width: "150px",
      },
      // { text: "Patient ID", value: "patient_id", sortable: false },
      {
        text: this.$t("page.profile.patient_name"),
        value: "patient_name",
        sortable: false,
        width: "250px",
        align: "center",
      },
      // { text: "Result", value: "result", sortable: false },
      {
        text: this.$t("page.profile.results"),
        value: "result",
        sortable: false,
        width: "100px",

        align: "center",
      },
      {
        text: this.$t("page.profile.referral_fee"),
        value: "referral",
        sortable: false,
        align: "center",
        width: "150px",
      },
    ];
    this.referralMonthHeader = [
      {
        text: this.$t("page.profile.date"),
        value: "date",
        sortable: false,
        align: "center",
        width: "130px",
      },
      {
        text: this.$t("page.profile.number_of_patients"),
        value: "patient",
        sortable: false,
        align: "center",
        width: "150px",
      },
      {
        text: this.$t("page.profile.referral_fee"),
        value: "fee",
        sortable: false,
        align: "center",
        width: "150px",
      },
    ];
    this.getDateThisWeek();
    this.getProfile();
    this.getInitialSummaryChart();
    this.getInitialReferralChart();
    this.getInitialReferralMonth();
    this.getInitialRevenue();
    this.getBulanBerjalan();
  },

  methods: {
    toggleDialogOrder(toggle) {
      this.dialog_order = toggle;
    },
    getFilterDateStrings() {
      /* eslint-disable no-unused-vars */
      this.dateString_today = this.dateNow;
      let stringWeek = "";
      let week = this.thisWeek;
      let first_week = week[0];
      let last_week = week[week.length - 1];
      if (moment(first_week).format("MM") == moment(last_week).format("MM")) {
        stringWeek = `${moment(first_week).format("DD")} - ${moment(
          last_week
        ).format("DD MMMM YYYY")}`;
      } else {
        stringWeek = `${moment(first_week).format("DD MMMM")} - ${moment(
          last_week
        ).format("DD MMMM YYYY")}`;
      }
      this.dateString_thisWeek = stringWeek;
      this.dateString_thisMonth = moment().format("MMMM YYYY");
      this.dateString_lastMonth = moment()
        .subtract(1, "months")
        .format("MMMM YYYY");
      this.dateString_last3Month = `${moment()
        .subtract(3, "months")
        .format("MMM YYYY")} - ${moment().format("MMM YYYY")} `;
      this.dateString_thisYear = `This Year (${moment().format("YYYY")})`;
      this.dateString_lifetime = "Lifetime";

      this.selectedDateNow = this.dateString_thisWeek; // init pertama kali
      this.selectedMonthNow = this.monthNow;

      /* eslint-enable no-unused-vars */
    },
    getBulanBerjalan() {
      const d = new Date();
      let month = d.getMonth() + 1;

      let month_list = [];
      for (var i = 1; i <= month; i++) {
        let month_name = moment.months(i - 1);
        let obj = {};
        obj["id"] = i;
        obj["name"] = month_name;
        month_list.push(obj);

        if (i == month) {
          this.bulanSekarang = { id: i, name: month_name };
        }
      }

      this.bulanBerjalan = month_list;
    },
    async openDialogOrder(item) {
      this.dataDialogOrder.order_id = item.order_id;
      this.getOrderDetailPopup();
      this.dialog_order = true;
    },
    async openDialogReferral(referral) {
      this.dataDialogReferral.selected_date = referral;
      this.getInitialRevenuePopup();
      this.dialog_referral = true;
    },

    async getInitialRevenue() {
      let show_by = this.dateFilterDefaultValue;
      try {
        const res = await API.get(
          `${process.env.VUE_APP_API_TRUST}referral/get-sap-revenue?show_by=` +
            show_by +
            `&group_by=date&approved_sap=1`,
          {
            "Content-Type": "application/json",
            Authorization: `Bearer ${Auth.getToken()}`,
          }
        );

        let dataSet = [];
        var tempData = [];
        for (const item in res.results) {
          let data_chart = res.results[item].detail;

          if (data_chart.length > 0) {
            dataSet = [...dataSet, ...data_chart];
          }
        }
        for (const dataNew in dataSet) {
          //logic untuk dapetin statusnya
          let status_invoice = dataSet[dataNew].invoice_status;
          let status_approved = dataSet[dataNew].approved;
          let overal_status = "";

          if (status_invoice == "paid" && status_approved == false) {
            overal_status = "warning";
          }
          if (status_invoice !== "paid" && status_approved == false) {
            overal_status = "danger";
          }
          if (status_invoice == "paid" && status_approved == true) {
            overal_status = "ok";
          }

          let status_parse = "-";

          let format_chart = {
            order_no: dataSet[dataNew].order_number,
            patient_id: dataSet[dataNew].patient_id_number,
            patient_name: dataSet[dataNew].patient,
            result: overal_status,
            status: status_parse,
            referral:
              dataSet[dataNew].amount !== null ? dataSet[dataNew].amount : 0,
            order_id: dataSet[dataNew].order_id,
            order_date: moment(dataSet[dataNew].invoice_date)
              .format("DD-MMM-YYYY")
              .toUpperCase(),
          };

          tempData.push(format_chart);
        }

        this.patientDatas = tempData;
      } catch (error) {
        console.log(error);
      }
    },
    async getInitialRevenuePopup() {
      let start_date = moment(this.dataDialogReferral.selected_date).format(
        "YYYY-MM-DD"
      );
      let end_date = start_date;

      try {
        const res = await API.get(
          `${process.env.VUE_APP_API_TRUST}referral/get-revenue?start_date=` +
            start_date +
            `&end_date=` +
            end_date +
            ``,
          {
            "Content-Type": "application/json",
            Authorization: `Bearer ${Auth.getToken()}`,
          }
        );
        // console.log(res);

        var tempData = [];
        for (const item in res.results) {
          let data_chart = res.results[item];
          //logic untuk dapetin statusnya
          let status_invoice = data_chart.invoice_status;
          let status_approved = data_chart.approved;
          let overal_status = "";

          if (status_invoice == "paid" && status_approved == false) {
            overal_status = "warning";
          }
          if (status_invoice !== "paid" && status_approved == false) {
            overal_status = "danger";
          }
          if (status_invoice == "paid" && status_approved == true) {
            overal_status = "ok";
          }

          let status_parse = "-";

          let format_chart = {
            order_no: data_chart.order_number,
            patient_id: data_chart.patient_id_number,
            patient_name: data_chart.patient,
            result: overal_status,
            status: status_parse,
            referral: data_chart.amount !== null ? data_chart.amount : 0,
          };

          tempData.push(format_chart);
        }

        this.patientDatasPopup = tempData;
      } catch (error) {
        console.log(error);
      }
    },
    async getInitialSummaryChart() {
      let show_by = this.dateFilterDefaultValue;
      try {
        const resp = await API.get(
          `${process.env.VUE_APP_API_TRUST}referral/get-sap-revenue?show_by=` +
            show_by +
            `&group_by=date&approved_sap=1`,
          {
            "Content-Type": "application/json",
            Authorization: `Bearer ${Auth.getToken()}`,
          }
        );

        var tempData = [];
        for (const item in resp.results) {
          let data_chart = resp.results[item];
          let format_chart = {
            ColorFlag: 0,
            MaximumValue: 200,
            MinimumValue: data_chart.number_of_patients,
            Result: data_chart.number_of_patients,
            Test: "",
            TestDate: data_chart.date,
            medical_record_number: "",
            name: "",
          };
          tempData.push(format_chart);
        }

        this.dataChart = tempData;
      } catch (error) {
        console.log(error);
      }
    },
    async getInitialReferralChart() {
      let show_by = this.dateFilterDefaultValue;
      try {
        const resp = await API.get(
          `${process.env.VUE_APP_API_TRUST}referral/get-sap-revenue?show_by=` +
            show_by +
            `&group_by=date&approved_sap=1`,
          {
            "Content-Type": "application/json",
            Authorization: `Bearer ${Auth.getToken()}`,
          }
        );
        // this.dataChart = {}
        var tempData = [];
        for (const item in resp.results) {
          let data_chart = resp.results[item];
          let format_chart = {
            ColorFlag: 0,
            MaximumValue: 200,
            MinimumValue: data_chart.number_of_patients,
            Result: data_chart.referral_fee,
            Test: "",
            TestDate: data_chart.date,
            medical_record_number: "",
            name: "",
          };
          tempData.push(format_chart);
        }

        this.dataReferralChart = tempData;
      } catch (error) {
        console.log(error);
      }
    },
    async getInitialReferralMonth() {
      let show_by = this.dateFilterDefaultValue;
      try {
        var url = "";
        url =
          `${process.env.VUE_APP_API_TRUST}referral/get-sap-revenue?show_by=` +
          show_by +
          `&group_by=date&approved_sap=1`;

        const resp = await API.get(url, {
          "Content-Type": "application/json",
          Authorization: `Bearer ${Auth.getToken()}`,
        });

        // var tempData1 = [];
        // for (const item in resp) {
        //   let data_chart = item;
        //   let date_formatted = new Date(data_chart.BUDAT);
        //   let format_chart = {
        //     date: date_formatted,
        //     patient: 'data_chart.number_of_patients',
        //     fee: data_chart.referral_fee,
        //   };
        //   tempData1.push(format_chart);
        // }

        //  for (const item in resp) {
        //   let data_chart = item;
        //   let date_formatted = new Date(data_chart.date);
        //   let format_chart = {
        //     date: date_formatted,
        //     patient: data_chart.number_of_patients,
        //     fee: data_chart.referral_fee,
        //   };
        //   tempData1.push(format_chart);
        // }

        // tempData1 = tempData1.sort(function (a, b) {
        //   var dateA = new Date(a.date).getTime();
        //   var dateB = new Date(b.date).getTime();
        //   return dateA < dateB ? 1 : -1; // ? -1 : 1 for ascending/increasing order
        // });

        // var tempData = [];
        // for (const item in tempData1) {
        //   let data_chart = tempData1[item];
        //   let format_chart = {
        //     date: moment(data_chart.date).format("DD-MMM-YYYY").toUpperCase(),
        //     patient: data_chart.patient,
        //     fee: data_chart.fee,
        //   };
        //   tempData.push(format_chart);
        // }

        // if(resp == ''){

        // }
        this.referralMonthData = resp.results;
      } catch (error) {
        this.referralMonthData = [];
        // console.log(error);
      }
    },
    async getProfile() {
      try {
        const resp = await API.get(`${process.env.VUE_APP_API_TRUST}profile`, {
          "Content-Type": "application/json",
          Authorization: `Bearer ${Auth.getToken()}`,
        });

        this.listMenu = [
          {
            id: 1,
            title: this.$t("tab.summary"),
          },
          {
            id: 2,
            title: this.$t("tab.personal_info"),
          },
          {
            id: 3,
            title: this.$t("tab.account_info"),
          },
          {
            id: 4,
            title: this.$t("tab.patient_list"),
          },
        ];
        this.listContent = [
          {
            id: 1,
            title: this.$t("tab.summary"),
            data: [
              {
                valueLeft:
                  resp.person == undefined
                    ? "-"
                    : resp.person.gender.name == "MALE"
                    ? "Mr. " + resp.person.personal_info.name
                    : "Mrs. " + resp.person.personal_info.name,
              },
              {
                valueLeft:
                  resp.person == undefined
                    ? "-"
                    : resp.person.personal_info.address.toUpperCase(),
              },
              {
                valueLeft:
                  resp.person == undefined
                    ? "-"
                    : resp.person.personal_info.city +
                      ", " +
                      resp.person.address.district,
              },
              {
                valueLeft:
                  resp.person == undefined
                    ? "-"
                    : resp.person.personal_info.state +
                      " " +
                      resp.person.personal_info.postal_code +
                      ", " +
                      resp.person.personal_info.country,
              },
              {
                valueTitle: "EMAIL",
                valueTitleLang: this.$t("field.email"),
                valueLeft:
                  resp.person == undefined
                    ? "-"
                    : resp.person.contacts.email == null
                    ? "-"
                    : resp.person.contacts.email,
              },
              {
                valueTitle: "MOBILE PHONE",
                valueTitleLang: this.$t("field.mobile_phone"),
                valueLeft:
                  resp.person == undefined
                    ? "-"
                    : resp.person.contacts.mobile_phone_number == null
                    ? "-"
                    : resp.person.contacts.mobile_phone_number,
              },
              {
                valueTitle: "HOME PHONE",
                valueTitleLang: this.$t("field.home_phone"),
                valueLeft:
                  resp.person == undefined
                    ? "-"
                    : resp.person.contacts.home_phone_number == null
                    ? "-"
                    : resp.person.contacts.home_phone_number,
              },
            ],
            dataRight: [
              {
                title: this.$t("field.sap_bp_id"),
                value: resp.sap_code,
              },

              {
                title: this.$t("field.id_card"),
                value:
                  resp.person == undefined
                    ? "-"
                    : resp.person.registered_ids[0].description,
              },

              {
                title: this.$t("field.gender"),
                value: resp.person == undefined ? "-" : resp.person.gender.name,
              },
              {
                title: this.$t("field.marital_status"),
                value:
                  resp.person == undefined
                    ? "-"
                    : resp.person.personal_info.marital_status == "null" ||
                      resp.person.personal_info.marital_status == null
                    ? "-"
                    : resp.person.personal_info.marital_status,
              },
              {
                title: this.$t("field.religion"),
                value:
                  resp.person == undefined
                    ? "-"
                    : resp.person.personal_info.religion == "null" ||
                      resp.person.personal_info.religion == null
                    ? "-"
                    : resp.person.personal_info.religion,
              },
              {
                title: this.$t("field.currency"),
                value: resp.currency,
              },
            ],
            dataMobile: [
              {
                valueLeft:
                  resp.person == undefined
                    ? "-"
                    : resp.person.gender.name == "MALE"
                    ? "Mr. " + resp.person.personal_info.name
                    : "Mrs. " + resp.person.personal_info.name,
              },
              {
                valueLeft:
                  resp.person == undefined
                    ? "-"
                    : resp.person.personal_info.address.toUpperCase(),
              },
              {
                valueLeft:
                  resp.person == undefined
                    ? "-"
                    : resp.person.personal_info.city +
                      ", " +
                      resp.person.address.district,
              },
              {
                valueLeft:
                  resp.person == undefined
                    ? "-"
                    : resp.person.personal_info.state +
                      " " +
                      resp.person.personal_info.postal_code +
                      ", " +
                      resp.person.personal_info.country,
              },
            ],
            dataMobileRight: [
              {
                title: this.$t("field.email"),
                value:
                  resp.person == undefined ? "-" : resp.person.contacts.email,
              },
              {
                title: this.$t("field.mobile_phone"),
                value:
                  resp.person == undefined
                    ? "-"
                    : resp.person.contacts.mobile_phone_number,
              },
              {
                title: this.$t("field.home_phone"),
                value:
                  resp.person == undefined
                    ? "-"
                    : resp.person.contacts.home_phone_number == "null" ||
                      resp.person.contacts.home_phone_number == null
                    ? "-"
                    : resp.person.contacts.home_phone_number,
              },

              {
                title: this.$t("field.id_card"),
                value:
                  resp.person == undefined
                    ? "-"
                    : resp.person.registered_ids[0].description,
              },
              {
                title: this.$t("field.sap_bp_id"),
                value: resp.sap_code,
              },
              {
                title: this.$t("field.gender"),
                value: resp.person == undefined ? "-" : resp.person.gender.name,
              },
              {
                title: this.$t("field.marital_status"),
                value:
                  resp.person == undefined
                    ? "-"
                    : resp.person.personal_info.marital_status == "null" ||
                      resp.person.personal_info.marital_status == null
                    ? "-"
                    : resp.person.personal_info.marital_status,
              },
              {
                title: this.$t("field.religion"),
                value:
                  resp.person == undefined
                    ? "-"
                    : resp.person.personal_info.religion == "null" ||
                      resp.person.personal_info.religion == null
                    ? "-"
                    : resp.person.personal_info.religion,
              },
              {
                title: this.$t("field.currency"),
                value: resp.currency,
              },
              // {
              //   title: this.$t("field.account_number"),
              //   value: resp.person.id,
              // },
              // {
              //   title: this.$t("field.sap_bp_id"),
              //   value: resp.sap_code,
              // },
              // {
              //   title: this.$t("field.national_id_card"),
              //   value: resp.person.registered_ids[1].description,
              // },
            ],
          },
          {
            id: 2,
            title: this.$t("tab.personal_info"),
            data: [
              {
                valueLeft:
                  resp.person == undefined
                    ? "-"
                    : resp.person.gender.name == "MALE"
                    ? "Mr. " + resp.person.personal_info.name
                    : "Mrs. " + resp.person.personal_info.name,
              },
              {
                valueLeft:
                  resp.person == undefined
                    ? "-"
                    : resp.person.personal_info.address.toUpperCase(),
              },
              {
                valueLeft:
                  resp.person == undefined
                    ? "-"
                    : resp.person.personal_info.city +
                      ", " +
                      resp.person.address.district,
              },
              {
                valueLeft:
                  resp.person == undefined
                    ? "-"
                    : resp.person.personal_info.state +
                      " " +
                      resp.person.personal_info.postal_code +
                      ", " +
                      resp.person.personal_info.country,
              },
              {
                valueTitle: "EMAIL",
                valueTitleLang: this.$t("field.email"),
                valueLeft:
                  resp.person == undefined
                    ? "-"
                    : resp.person.contacts.email == null
                    ? "-"
                    : resp.person.contacts.email,
              },
              {
                valueTitle: "MOBILE PHONE",
                valueTitleLang: this.$t("field.mobile_phone"),
                valueLeft:
                  resp.person == undefined
                    ? "-"
                    : resp.person.contacts.mobile_phone_number == null
                    ? "-"
                    : resp.person.contacts.mobile_phone_number,
              },
              {
                valueTitle: "HOME PHONE",
                valueTitleLang: this.$t("field.home_phone"),
                valueLeft:
                  resp.person == undefined
                    ? "-"
                    : resp.person.contacts.home_phone_number == null
                    ? "-"
                    : resp.person.contacts.home_phone_number,
              },
            ],
            dataRight: [
              {
                title: this.$t("field.sap_bp_id"),
                value: resp.sap_code,
              },
              {
                title: this.$t("field.id_card"),
                value:
                  resp.person == undefined
                    ? "-"
                    : resp.person.registered_ids[0].description,
              },

              {
                title: this.$t("field.gender"),
                value: resp.person == undefined ? "-" : resp.person.gender.name,
              },
              {
                title: this.$t("field.marital_status"),
                value:
                  resp.person == undefined
                    ? "-"
                    : resp.person.personal_info.marital_status == "null" ||
                      resp.person.personal_info.marital_status == null
                    ? "-"
                    : resp.person.personal_info.marital_status,
              },
              {
                title: this.$t("field.religion"),
                value:
                  resp.person == undefined
                    ? "-"
                    : resp.person.personal_info.religion == "null" ||
                      resp.person.personal_info.religion == null
                    ? "-"
                    : resp.person.personal_info.religion,
              },
              {
                title: this.$t("field.currency"),
                value: resp.currency,
              },
            ],
            dataMobile: [
              {
                valueLeft:
                  resp.person == undefined
                    ? "-"
                    : resp.person.gender.name == "MALE"
                    ? "Mr. " + resp.person.personal_info.name
                    : "Mrs. " + resp.person.personal_info.name,
              },
              {
                valueLeft:
                  resp.person == undefined
                    ? "-"
                    : resp.person.personal_info.address.toUpperCase(),
              },
              {
                valueLeft:
                  resp.person == undefined
                    ? "-"
                    : resp.person.personal_info.city +
                      ", " +
                      resp.person.address.district,
              },
              {
                valueLeft:
                  resp.person == undefined
                    ? "-"
                    : resp.person.personal_info.state +
                      " " +
                      resp.person.personal_info.postal_code +
                      ", " +
                      resp.person.personal_info.country,
              },
            ],
            dataMobileRight: [
              {
                title: this.$t("field.email"),
                value:
                  resp.person == undefined ? "-" : resp.person.contacts.email,
              },
              {
                title: this.$t("field.mobile_phone"),
                value:
                  resp.person == undefined
                    ? "-"
                    : resp.person.contacts.mobile_phone_number,
              },
              {
                title: this.$t("field.home_phone"),
                value:
                  resp.person == undefined
                    ? "-"
                    : resp.person.contacts.home_phone_number == "null" ||
                      resp.person.contacts.home_phone_number == null
                    ? "-"
                    : resp.person.contacts.home_phone_number,
              },

              {
                title: this.$t("field.id_card"),
                value:
                  resp.person == undefined
                    ? "-"
                    : resp.person.registered_ids[0].description,
              },
              {
                title: this.$t("field.sap_bp_id"),
                value: resp.sap_code,
              },
              {
                title: this.$t("field.gender"),
                value: resp.person == undefined ? "-" : resp.person.gender.name,
              },
              {
                title: this.$t("field.marital_status"),
                value:
                  resp.person == undefined
                    ? "-"
                    : resp.person.personal_info.marital_status == "null" ||
                      resp.person.personal_info.marital_status == null
                    ? "-"
                    : resp.person.personal_info.marital_status,
              },
              {
                title: this.$t("field.religion"),
                value:
                  resp.person == undefined
                    ? "-"
                    : resp.person.personal_info.religion == "null" ||
                      resp.person.personal_info.religion == null
                    ? "-"
                    : resp.person.personal_info.religion,
              },
              {
                title: this.$t("field.currency"),
                value: resp.currency,
              },
              // {
              //   title: this.$t("field.account_number"),
              //   value: resp.person.id,
              // },
              // {
              //   title: this.$t("field.sap_bp_id"),
              //   value: resp.sap_code,
              // },
              // {
              //   title: this.$t("field.national_id_card"),
              //   value: resp.person.registered_ids[1].description,
              // },
            ],
          },
          //section hospital
          {
            // id: 2,
            // title: this.$t("personal_information"),
            // data: [
            //   {
            //     title: this.$t("hospital_id"),
            //     value: resp.person.hospital_info.hospital_id,
            //   },
            //   {
            //     title: this.$t("state"),
            //     value: resp.person.hospital_info.hospital_state,
            //   },
            //   {
            //     title: this.$t("hospital_name"),
            //     value: resp.person.hospital_info.hospital_name,
            //   },
            //   {
            //     title: this.$t("district"),
            //     value: resp.person.hospital_info.hospital_district == 'null' || resp.person.hospital_info.hospital_district == null  ? '-' : resp.person.hospital_info.hospital_district,
            //   },
            //   {
            //     title: this.$t("address"),
            //     value: resp.person.hospital_info.hospital_address,
            //   },
            //   {
            //     title: this.$t("postal_code"),
            //     value: resp.person.hospital_info.hospital_postal_code,
            //   },
            //   {
            //     title: this.$t("city"),
            //     value: resp.person.hospital_info.hospital_city,
            //   },
            //   {
            //     title: this.$t("country"),
            //     value: resp.person.hospital_info.hospital_country,
            //   },
            // ],
          },
          //section education info
          {
            id: 3,
            title: this.$t("tab.personal_info"),
            data: [
              {
                title: "Hospital Id",
                value:
                  resp.person == undefined
                    ? "-"
                    : resp.person.hospital_info == "null" ||
                      resp.person.hospital_info == null
                    ? "-"
                    : resp.person.hospital_info.hospital_id,
              },
              {
                title: this.$t("field.state"),
                value:
                  resp.person == undefined
                    ? "-"
                    : resp.person.hospital_info == "null" ||
                      resp.person.hospital_info == null
                    ? "-"
                    : resp.person.hospital_info.hospital_state,
              },
              {
                title: "hospital name",
                value:
                  resp.person == undefined
                    ? "-"
                    : resp.person.hospital_info == "null" ||
                      resp.person.hospital_info == null
                    ? "-"
                    : resp.person.hospital_info.hospital_name,
              },
              {
                title: this.$t("field.district"),
                value:
                  resp.person == undefined
                    ? "-"
                    : resp.person.hospital_info == "null" ||
                      resp.person.hospital_info == null
                    ? "-"
                    : resp.person.hospital_info.hospital_district,
              },
              {
                title: this.$t("field.address"),
                value:
                  resp.person == undefined
                    ? "-"
                    : resp.person.hospital_info == "null" ||
                      resp.person.hospital_info == null
                    ? "-"
                    : resp.person.hospital_info.hospital_address,
              },
              {
                title: this.$t("field.postal_code"),
                value:
                  resp.person == undefined
                    ? "-"
                    : resp.person.hospital_info == "null" ||
                      resp.person.hospital_info == null
                    ? "-"
                    : resp.person.hospital_info.postal_code,
              },
              {
                title: this.$t("field.city"),
                value:
                  resp.person == undefined
                    ? "-"
                    : resp.person.hospital_info == "null" ||
                      resp.person.hospital_info == null
                    ? "-"
                    : resp.person.hospital_info.hospital_city,
              },
              {
                title: this.$t("field.country"),
                value:
                  resp.person == undefined
                    ? "-"
                    : resp.person.hospital_info == "null" ||
                      resp.person.hospital_info == null
                    ? "-"
                    : resp.person.hospital_info.hospital_countrys,
              },
            ],
          },
          {
            id: 4,
            title: this.$t("page.profile.tax_info"),
            data: [
              {
                title: this.$t("page.profile.npwp_number"),
                value:
                  resp.person == undefined
                    ? "-"
                    : resp.person.tax == "null" || resp.person.tax == null
                    ? "-"
                    : resp.person.tax.npwp_number,
              },
              {
                title: this.$t("page.profile.npwp_registration_date"),
                value: "-",
              },
              {
                title: this.$t("page.profile.npwp_address"),
                value:
                  resp.person == undefined
                    ? "-"
                    : resp.person.tax == "null" || resp.person.tax == null
                    ? "-"
                    : resp.person.tax.npwp_address,
              },
            ],
          },
          {
            id: 5,
            title: this.$t("page.profile.bank_info"),
            data: [
              {
                title: this.$t("page.profile.bank_name"),
                value:
                  resp.person == undefined
                    ? "-"
                    : resp.person.bank_account == "null" ||
                      resp.person.bank_account == null
                    ? "-"
                    : resp.person.bank_account.bank_name,
              },
              {
                title: this.$t("page.profile.bank_branch"),
                value:
                  resp.person == undefined
                    ? "-"
                    : resp.person.bank_account == "null" ||
                      resp.person.bank_account == null
                    ? "-"
                    : resp.person.bank_account.bank_branch,
              },
              {
                title: this.$t("page.profile.bank_account_number"),
                value:
                  resp.person == undefined
                    ? "-"
                    : resp.person.bank_account == "null" ||
                      resp.person.bank_account == null
                    ? "-"
                    : resp.person.bank_account.bank_account_number,
              },
              {
                title: this.$t("page.profile.bank_account_name"),
                value:
                  resp.person == undefined
                    ? "-"
                    : resp.person.bank_account == "null" ||
                      resp.person.bank_account == null
                    ? "-"
                    : resp.person.bank_account.bank_account_name,
              },
            ],
          },
        ];
        this.dataTaxInfo =
          resp.person == undefined ? null : resp.person.tax_info;
      } catch (error) {
        console.log(error);
      }
      if (this.listContent != null) {
        this.activeTab = this.listContent[0].id;
      }
    },
    async getOrderDetailPopup() {
      let order_id = this.dataDialogOrder.order_id;

      try {
        const res = await API.get(
          `${process.env.VUE_APP_API_TRUST}lab-results/get-detail?order_id=` +
            order_id +
            ``,
          {
            "Content-Type": "application/json",
            Authorization: `Bearer ${Auth.getToken()}`,
          }
        );

        this.dataDialogOrder.list = res.results;
      } catch (error) {
        console.log(error);
      }
    },
    calculateDoughnut() {
      var totalDoughnut = 0;
      this.dataDoughnut.forEach(element => {
        totalDoughnut = element.Result + totalDoughnut;
      });
      const activeDoughnutIndex = this.dataDoughnut.findIndex(
        item => item.id == this.activeDoughnut
      );
      if (activeDoughnutIndex >= 0) {
        this.percentDoughnut = parseInt(
          (this.dataDoughnut[activeDoughnutIndex].Result / totalDoughnut) * 100
        );
      }
    },
    setActiveDoughnut(param) {
      if (param == 1) {
        this.colorPercent = "#2ED47A";
      } else if (param == 2) {
        this.colorPercent = "#FFB946";
      } else if (param == 3) {
        this.colorPercent = "#F7685B";
      } else {
        this.colorPercent = "#0000DE";
      }
      this.activeDoughnut = param;
      this.calculateDoughnut();
    },
    getDateThisWeek() {
      const date = moment();
      const startThisWeek = moment(date).startOf("isoWeek");
      const endThisWeek = moment(date).endOf("isoWeek");
      this.thisWeek = this.getListDateRange(startThisWeek, endThisWeek);
    },
    getListDateRange(startDate, endDate) {
      var start = new Date(startDate);
      var end = new Date(endDate);
      var dates = [];

      while (start <= end) {
        dates.push(new Date(start));
        start.setDate(start.getDate() + 1);
      }
      return dates;
    },
    sumField(key) {
      // sum data in give key (property)
      return this.datas.reduce((a, b) => a + (b[key] || 0), 0);
    },
    sumReferral() {
      // sum data in give key (property)
      let sum = 0;

      for (let i = 0; i < this.patientDatas.length; i++) {
        // if (this.patientDatas[i].status == "Active" ||  this.patientDatas[i].status == "Completed") {
        //   sum = sum + parseInt(this.patientDatas[i].referral);
        // }

        // if (
        //   this.patientDatas[i].result == "ok" ||
        //   this.patientDatas[i].result == "warning"
        // ) {
        sum = sum + parseInt(this.patientDatas[i].referral);
        // }
      }
      return sum;
    },
    sumReferralPopup() {
      let sum = 0;
      for (let i = 0; i < this.patientDatasPopup.length; i++) {
        // if (
        //   this.patientDatasPopup[i].result == "ok" ||
        //   this.patientDatasPopup[i].result == "warning"
        // ) {

        sum = sum + parseInt(this.patientDatasPopup[i].referral);
        // }
      }
      return sum;
    },
    sumReferralMonth(key) {
      // sum data in give key (property)
      return this.referralMonthData.reduce(
        (a, b) => a + (parseFloat(b[key]) || 0),
        0
      );
    },
    updateSummaryChart(e) {
      // this.dateFilterDefaultValue.dateValue = e;
      this.dateFilterDefaultValue = e;
      this.getInitialSummaryChart();
    },
    updateReferralChart(e) {
      this.dateFilterDefaultValue = e;
      this.getInitialReferralChart();
    },
    updateRevenue(e) {
      this.dateFilterDefaultValue = e;
      this.getInitialRevenue();
    },
    updateDailyReferralMonth(e) {
      // let current_year = moment().format("YYYY");
      // let month = e;
      // let string_first_date = `${current_year}-${month}-1`;
      // let first_date = new Date(string_first_date);
      // let first_date_format = moment(first_date).format("YYYYMMDD");
      // let last_date_format = moment(first_date)
      //   .endOf("month")
      //   .format("YYYYMMDD");

      // this.selectedMonthNow = moment(first_date).format("MMMM YYYY");
      // this.getInitialReferralMonth(first_date_format, last_date_format);
      this.dateFilterDefaultValue = e;
      this.getInitialReferralMonth();
    },
    updateAllReport(e) {
      this.dateFilterDefaultValue = e;
      this.getInitialRevenue();
      this.getInitialReferralChart();
      this.getInitialSummaryChart();
      this.getInitialReferralMonth();
      switch (e) {
        case "today":
          this.selectedDateNow = this.dateString_today;
          break;
        case "this_week":
          this.selectedDateNow = this.dateString_thisWeek;
          break;
        case "this_month":
          this.selectedDateNow = this.dateString_thisMonth;
          break;
        case "last_month":
          this.selectedDateNow = this.dateString_lastMonth;
          break;
        case "last_3_month":
          this.selectedDateNow = this.dateString_last3Month;
          break;
        case "this_year":
          this.selectedDateNow = this.dateString_thisYear;
          break;
        case "life_time":
          this.selectedDateNow = this.dateString_lifetime;
          break;
        default:
          this.selectedDateNow = this.dateString_thisWeek;
          break;
      }
    },
    formater(value) {
      let angka = parseInt(value) || 0;
      let nilai = angka.toLocaleString("en-US", { minimumFractionDigits: 2 });
      return nilai;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/color.scss";
.home {
  display: flex;
  flex-direction: column;
  padding: 1px 0 40px 0;
  &__section {
    padding: 0 20px;
  }
}
.center-empty {
  display: flex;
  justify-content: center;
  align-items: center;
}
.tab-switch {
  color: $main_2;
  margin-right: 8px;
}

.h4 {
  color: $main_2;
}
.list-data {
  border-bottom: 1px solid $gray_2;
  // padding: 4px 8px 0 8px;
  padding: 12px 8px 0 8px;
  height: 100%;
}
.pointer {
  cursor: pointer;
}
.card-chart {
  position: relative;
}
.text-title {
  font-size: 12px;
  text-transform: uppercase;
  color: $main_2;
  font-weight: bold;
}
.text-value {
  font-size: 12px;
  text-transform: uppercase;
  color: #000;
  text-align: right;
}

.v-tabs {
  width: 720px;
}

.center-chart {
  background: transparent;
  height: 80%;
  width: 80%;
  left: 50%;
  top: 52%;
  transform: translate(-50%, -50%);
  border-radius: 50%;
  position: absolute;
  z-index: 99;
  display: flex;
  justify-content: center;
  align-items: center;
  p {
    font-size: 72px;
    margin-bottom: 0;
  }
}
.label-doughnut {
  align-self: center;
}
.doughnut-title {
  padding: 4px;
}
.chart-title {
  padding: 4px 12px;
}

.v-input__control {
  height: 30px;
}
.v-input__slot {
  height: 30px;
}

.v-select__selections {
  width: 30px;
  height: 30px;
}

.v-select {
  height: 30px;
  background: #ffb946;
  color: #000;
}

.sticky-table-footer {
  td {
    font-weight: bold;
  }
}

.card-chart .v-data-table {
  td {
    font-size: 12px;
  }
}

.table-patient {
  th {
    .text-gray {
      color: $main_2;
      margin: 0;
      font-style: normal;
      font-weight: 500;
      font-size: 14px;
      line-height: 20px;
    }
  }
  td {
    .text-gray {
      color: $gray_table;
      margin: 0;
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      line-height: 20px;
    }
    .text-black {
      color: $black_table;
      margin: 0;
      font-style: normal;
      font-weight: 500;
      font-size: 14px;
      line-height: 20px;
    }
  }
}

.v-data-table > .v-data-table__wrapper > table > tbody > tr > td {
  font-size: 12px;
  vertical-align: baseline;
  padding-top: 6px;
  padding-bottom: 6px;
  height: 25px !important;
}

.v-data-table > .v-data-table__wrapper > table > thead > tr > th {
  height: 35px !important;
}

.grey-color {
  background: #eeeeee;
}

.head-vir {
  background: #1a428a;
  color: #fff;
}

.head-vir2 {
  background: #6dc6d6;
  font-weight: bold;
}

.head-vir2:hover {
  background: #6dc6d6 !important;
}

.head-vir2 th {
  color: #000 !important;
}

.bold {
  font-weight: bold;
}

.hover-apri:hover {
  background: rgba(113, 188, 225, 0.1) !important;
}
.hover-apri:hover td {
  font-weight: bold;
}
.text-title {
  font-size: 12px;
  text-transform: uppercase;
  color: $main_2;
  font-weight: bold;
}
.text-new-title {
  font-size: 12px;
  text-transform: uppercase;
  color: #000;
}
.text-value {
  font-size: 12px;
  text-transform: uppercase;
  color: #000;
  text-align: right;
}
</style>
<style>
.super-dense > .v-data-table__wrapper > table > tbody > tr > td,
.super-dense > .v-data-table__wrapper > table > tbody > tr > th,
.super-dense > .v-data-table__wrapper > table > thead > tr > td,
.super-dense > .v-data-table__wrapper > table > thead > tr > th,
.super-dense > .v-data-table__wrapper > table > tfoot > tr > td {
  height: 35px !important;
}
.table-stick .v-data-table__wrapper {
  overflow-x: auto;
  overflow-y: auto;
  height: 407px;
}
.table-stick thead {
  position: sticky;
  inset-block-start: 0;
  top: 0;
  background: #ddd !important;
  font-weight: bold;
  color: #000 !important;
}
.table-stick-sap .v-data-table__wrapper {
  overflow-x: auto;
  overflow-y: auto;
  height: 345px;
}
.table-stick-sap thead {
  position: sticky;
  inset-block-start: 0;
  top: 0;
  background: #ddd !important;
  font-weight: bold;
  color: #000 !important;
}

.table-list-patient thead {
  background: #ddd !important;
  font-weight: bold;
  color: #000 !important;
}
.table-list-patient thead tr th {
  height: 38px !important;
}
.table-list-patient tbody tr td {
  font-size: 12px !important;
  height: 35px !important;
}
.table-list-patient tbody tr:hover {
  background-color: transparent !important;
}
</style>
